import React, { useCallback, useState, useEffect } from "react";
import { useDropzone } from "react-dropzone";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faUpload, faTimes } from "@fortawesome/pro-light-svg-icons";
import { useDeepEffect } from "../../abstracts";
import { get } from "lodash";
import AddToolTip from "../AddToolTip";
// import DocViewer, { DocViewerRenderers } from "react-doc-viewer";

const UploadSSHComponent = (props) => {
  const {
    setFieldValue,
    label,
    name,
    values,
    clearUploadFile,
    setFileUploadRequired,
    setNewFile,
    clearField,
    setClearField,
    setShowFileName,
    fileExtensions,
    fieldName = "uploadSourceFile",
  } = props;
  const [myFiles, setMyFiles] = useState(get(values, fieldName, []));
  const [isUploadSuccess, setIsUploadSuccess] = useState(true);
  const [edit, setEdit] = useState(false);
  function getBlobURL() {
    return URL.createObjectURL(myFiles[0]);
  }

  useEffect(() => {
    if (values && values.sshKey) {
      setMyFiles([values.sshKey]); // Set the file for rendering
    }
  }, [values]);

  const onDrop = useCallback(
    async (acceptedFiles) => {
        const validatePemFile = (file) => {
            try {
              // Check if the file extension is .pem or .key
              const fileName = file.name.toLowerCase();
              if (fileName.endsWith(".pem") || fileName.endsWith(".key")) {
                return true; // Valid file extension
              }
              console.error("Invalid file type. Only .pem and .key files are allowed.");
              return false; // Invalid file extension
            } catch (error) {
              console.error("Error validating file:", error);
              return false;
            }
          };
          
      const readFileAsBase64 = (file) => {
        return new Promise((resolve, reject) => {
          const reader = new FileReader();
          reader.onloadend = () => {
            // Extract base64-encoded data from the data URL
            const base64Data = reader.result.split(',')[1];
            resolve(base64Data);
          };
          reader.onerror = reject;
          reader.readAsDataURL(file); // Read file as data URL
        });
      };
      const isValid = await validatePemFile(acceptedFiles[0]);
      if(isValid){
        if (myFiles?.length === 0) {
            var base64byteArray = await readFileAsBase64(acceptedFiles[0]);
            var fileValue = {
                fileName : acceptedFiles[0].name,
                Content : base64byteArray
            };
            setMyFiles([...myFiles, fileValue]);
            setFieldValue(name, fileValue);
            if (setNewFile) {
              setNewFile(name, fileValue);
            }
          }
          if (acceptedFiles.length === 0) {
            setIsUploadSuccess(false);
          } else {
            setIsUploadSuccess(true);
            setFileUploadRequired("");
          }
      }
      else{
        setIsUploadSuccess(false);
      }
      
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [myFiles]
  );
  useDeepEffect(() => {
    if (clearField) {
      setMyFiles([]);
      setClearField(false);
      setShowFileName(true);
    }
  }, [clearField]);

  // useDeepEffect(() => {
  //   setEdit(true);
  //   setMyFiles([get(values, fieldName, [])]);
  // }, [values]);

  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    onDrop,
    multiple: false,
    accept: fileExtensions,
  });

  const removeFile = (file) => () => {
    const newFiles = [...myFiles];
    if (setFileUploadRequired) {
      setFileUploadRequired("");
    }
    newFiles.splice(newFiles.indexOf(file), 1);
    setMyFiles(newFiles);
    if (clearUploadFile) {
      clearUploadFile();
    }
    if (setNewFile) {
      setNewFile([]);
      setFieldValue(name, undefined);
      setShowFileName(true);
    }
  };
  
  const files = myFiles.map((file) => {
    return (
        <div className="d-flex" style={{ justifyContent: "flex-start" }}>
          <span
            style={{
              textOverflow: "ellipsis",
            }}
          >
            {(
              file.fileName.length > 25 ? (
                <AddToolTip name={file.fileName}>
                  <div>
                    {(file.fileName || "").slice(0, 15)}...
                    {(file.fileName || "").slice(
                      file.fileName.length - 16,
                      file.fileName.lastIndexOf(".")
                    )}
                    {(file.fileName || "").slice(
                      file.fileName.lastIndexOf("."),
                      file.fileName.length
                    )}{" "}
                  </div>
                </AddToolTip>
              ) : (
                <div>
                  {file.fileName}{" "}
                </div>
              )
            ) }
          </span>
          <span
            className="ml-4"
            style={{ cursor: "pointer" }}
            onClick={removeFile(file)}
          >
            <FontAwesomeIcon
              icon={faTimes}
              color={"#ff0000"}
              onClick={() => setFieldValue(name, undefined)}
            />
          </span>
        </div>
      )
    }
  );

  const getClassName = isUploadSuccess
    ? "upload-docs border-color-normal"
    : "upload-docs border-color-red";

  return (
    <div>
      {}
      <label className="label-text-upload">{label}</label>
      <div {...getRootProps({ className: "dropzone" })}>
        <input name={name} {...getInputProps()} disabled={myFiles.length} />
        <div className={getClassName}>
          <FontAwesomeIcon icon={faUpload} />
          <p> Drag & Drop Here</p>
          <p> or</p>
          <p className="link-text"> Browse file</p>
        </div>
      </div>
      <span className="file-type-upload">
        Accepted File Type : {fileExtensions}
      </span>
      <p className="file-type-red">
        {!isUploadSuccess ? "*Please upload a valid file" : null}
      </p>
      { files}
      {/* {enablePreview && isUploadSuccess && <img src="https://storageaccountcore2ad3a.blob.core.windows.net/employeeimagecontainer/1" />
      } */}
      {/* {enablePreview && isUploadSuccess && (
        <img
          style={{ width: "75%", height: "75%" }}
          src={URL.createObjectURL(myFiles[0])}
        />
      )} */}
      {/* <object data="https://storageaccountcore2ad3a.blob.core.windows.net/inputfile/InputFile_2021-05-09-12-05-54.xlsx" type="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" width="100%" height="100%">
      <p>Alternative text - include a link <a href="https://storageaccountcore2ad3a.blob.core.windows.net/inputfile/InputFile_2021-05-09-12-05-54.xlsx">to the PDF!</a></p>
  </object> */}
      {/* {enablePreview && (
        <DocViewer DocViewerRenderers={DocViewerRenderers} documents={docs} />
      )} */}
      {/* <object data={URL.createObjectURL(new Blob(myFiles[0], {type: "application/pdf"}))} type="application/pdf" width="50%" height="50%">
  </object> */}
    </div>
  );
};

export default UploadSSHComponent;
